import { ExposedFilterPropsMapper } from '../types';

export const professionFiltersPropsMapper: ExposedFilterPropsMapper = (context) => {
    const { appFilters: { exposedFilters } = {} } = context;
    const professionFilter = exposedFilters?.profession_filters?.[0];

    return { professionFilter };
};
